module.exports = {
	"api.httpinterceptor.q6n8xn": "Request error",
	"api.request.qpc7ar": "URL is empty",
	"error.link-error.48h4ct": "Error occurred",
	"error.link-error.232d19": "Invalid parameter: ",
	"error.link-error.44gd55": "Learn about Zhida",
	"login.auto-login.qgn7zj": "This account is in use, you can log in directly",
	"login.auto-login.25v959": "Log in now",
	"login.create-org.5x9f8l": "This account has not created an organization yet",
	"login.create-org.21r5sh": "Before entering the system, you need to create an organization to log in",
	"login.create-org.8plaol": "You can also choose:",
	"login.create-org.21d3fj": "1. Change account and log in again",
	"login.create-org.g76h7u": "2. Create a new organization directly",
	"login.create-org.698vk9": "Create Organization",
	"login.create-org.o6sy8f": "Return to login",
	"login.forget-pwd-form.l3v7ay": "Forgot Password",
	"login.forget-pwd-form.l112dc": "Get Verification Code",
	"login.forget-pwd-form.nfdbmd": "Confirm",
	"login.forget-pwd-form.6b2385": "Phone Number",
	"login.forget-pwd-form.bh5mmc": "Verification Code",
	"login.forget-pwd-form.38ykjf": "Please enter password",
	"login.forget-pwd-form.z38j76": "Please re-enter password",
	"login.forget-pwd-form.u4e59h": "Please enter phone number",
	"login.forget-pwd-form.8i833l": "Please enter 11-digit phone number",
	"login.forget-pwd-form.6a0s18": "Please enter correct phone number",
	"login.forget-pwd-form.ogpkw8": "Two password entries do not match!",
	"login.forget-pwd-form.lblo1h": "Please enter verification code",                       
	"login.forget-pwd-form.ch4q37": "Length between 6 to 18 characters",
	"login.forget-pwd-form.9wickx": "Resend after seconds",
	"login.forget-pwd-form.fo4848": "Password reset successful",
	"login.login-form.3r4v7j": "Account",
	"login.login-form.2ggb48": "Verification Code",
	"login.login-form.7469hh": "I have read and agree to the ",
	"login.login-form.7k35mt": " User Agreement ",
	"login.login-form.v57f76": "and",
	"login.login-form.4fh3v2": " Privacy Policy",
	"login.login-form.f68387": "No account? ",
	"login.login-form.4f8kmx": " Register now",
	"login.login-form.k81141": "Disagree",
	"login.login-form.khw9mg": "Agree",
	"login.login-form.r32x8v": "Please enter phone number",
	"login.login-form.3ou3jl": "Logging in",
	"login.login-form.7dys59": "Login",
	"login.login-form.er7m32": "Service Agreement and Privacy Protection",
	"login.login-form.voe6p1": "Please enter correct phone number",
	"login.login-form.p2b47q": "Failed to obtain permissions",
	"login.organization-form.ffr26f": "Created, ",
	"login.organization-form.8d4h47": "Go to login",
	"login.organization-form.c28qj8": "Cancel",
	"login.organization-form.j6k616": "Create",
	"login.organization-form.42561l": "Organization Name",
	"login.organization-form.2yf5w0": "Please enter organization name",
	"login.organization-form.42lv18": "Industry",
	"login.organization-form.uo5qu2": "Organization Address",
	"login.organization-form.468ed5": "Detailed Address",
	"login.organization-form.1w9e7q": "Please enter detailed address",
	"login.organization-form.593f87": "Organization Size",
	"login.organization-form.ol3z15": "Please select organization size",
	"login.organization-form.4dij6m": "Email",
	"login.organization-form.46ruo4": "Please enter email",
	"login.organization-form.433t4x": "Organization Website",
	"login.organization-form.hbxo94": "Please enter organization website",
	"login.organization-form.4792wb": "Unified Social Credit Code",
	"login.organization-form.223s8k": "Please enter unified social credit code",
	"login.organization-form.1kjk8u": "Please select industry",
	"login.organization-form.fp4680": "Uploaded avatar image size cannot exceed 2MB!",
	"login.organization-form.neh7n5": "Organization created successfully",
	"login.register-form.84p6e2": "Register",
	"login.register-form.23f2xb": "Already have an account?",
	"login.register-form.u87f5r": "Log in directly",
	"login.register-form.2i85b6": "Register",
	"login.register-form.is6m7q": "Name",
	"login.register-form.8330bi": "Password",
	"login.register-form.4l2ie7": "Confirm Password",
	"login.register-form.86ng42": "Please enter name",
	"login.register-form.31lw5q": "Account registered successfully",
	"login.select-org.730r1v": "Return",
	"login.select-org.3b3q2h": "Create New Organization",
	"login.select-org.7q7p85": "Select the organization you have joined",
	"login.select-org.t19w2e": "Please select an organization to enter from the following",
	"login.select-org.u444bq": "Last Login",
	"components.create-organization.72xnpc": "Create a new organization and establish a connection, you will become the organization administrator",
	"components.create-organization.y342cq": "This organization has been created, you can share the link to invite the other party to agree to establish a connection.",
	"components.create-organization.3mslgc": "Link Address",
	"components.create-organization.3f8p18": "Share Link",
	"components.create-organization.qgzi5t": "Tips",
	"components.create-organization.234egt": "Name cannot contain special characters",
	"components.create-organization.8y8hov": "Please enter correct credit code",
	"components.create-organization.38lfsg": "Please enter correct email address",
	"components.create-organization.1um050": "Modification successful",
	"components.create-organization.685yf4": "Organization name already exists!",
	"components.create-organization.38385x": "Please configure Zhida platform address",
	"components.create-organization.k2gz3p": "Dear partner, we sincerely invite you to establish a connection with us to achieve inter-enterprise data reporting, process approval, etc. based on 'Zhida'. Looking forward to cooperating with you!",
	"components.create-organization.d9toyb": "\nInviter: ",
	"components.create-organization.g5zaru": "\nInvitation link: ",
	"components.create-organization.4ycqk7": "Link copied",
	"components.create-organization.ea7r67": "Link copy failed",
	"components.edit-organization.w4f6r5": "Edit Organization",
	"components.levels-add-dialog.6i0i7a": "Department Name",
	"components.levels-add-dialog.f155cf": "Please enter department name",
	"components.levels-add-dialog.td3h61": "Parent Department",
	"components.levels-add-dialog.0u49t1": "Name cannot be empty",
	"components.levels-add-dialog.3y8l6k": "Edit Department",
	"components.levels-add-dialog.n0opre": "Add Department",
	"components.related-app.c73l6q": "Related Applications",
	"components.related-app.ki6n24": "Application Name",
	"components.related-app.j5sss3": "Please select application",
	"components.staff-dialog.35h0xf": "Note:",
	"components.staff-dialog.1880mx": "1. If the entered phone number is not registered, an account will be automatically registered and added to the organization. The initial password is wlw@123456",
	"components.staff-dialog.eo737j": "2. If the entered phone number is already registered, it will be directly added to the organization",
	"components.staff-dialog.u6ir43": "Set as organization administrator",
	"components.staff-dialog.8j27h5": "Cancel",
	"components.staff-dialog.n6alc2": "Confirm",
	"components.staff-dialog.f05515": "Add",
	"components.staff-dialog.f6xvja": "Edit",
	"components.staff-dialog.760u28": "Save",
	"components.staff-dialog.h65044": "Delete",
	"components.staff-dialog.22f184": "Department",
	"components.staff-dialog.s662ls": "Position",
	"components.staff-dialog.qozha7": "Please select",
	"components.staff-dialog.7m4es2": "Position Settings",
	"components.staff-dialog.67gji4": "Position Name",
	"components.staff-dialog.g4ec7x": "Please enter position name",
	"components.staff-dialog.bkn111": "Operation",
	"components.staff-dialog.35nh68": "Name cannot be empty",
	"components.staff-dialog.5e2nc4": "Phone number cannot be empty",
	"components.staff-dialog.b4p7lc": "Please select department",
	"components.staff-dialog.38g662": "Add Member",
	"components.staff-dialog.w6wp80": "Maximum 30 types can be added",
	"components.staff-dialog.he0584": "Please enter position name without special characters",
	"components.staff-dialog.q25fz3": "Confirm to delete position?",
	"components.staff-dialog.p77gw4": "Warning",
	"components.structure.87x93f": "Disconnect",
	"components.structure.1rn1sl": "Delete Department",
	"components.structure.978u38": "Search",
	"components.structure.bxil03": "Reset",
	"components.structure.08dlw6": "Add Staff",
	"components.structure.227r0q": "Add Workbench",
	"components.structure.tef8j8": "Batch Delete",
	"components.structure.5749t2": "Please enter name",
	"components.structure.myn2rj": "Index",
	"components.structure.eof9nq": "Role",
	"components.structure.3yh751": "Are you sure to delete this department? It cannot be recovered after deletion.",
	"components.structure.nm7p8o": "Cancel Department Administrator",
	"components.structure.49rd61": "Set Department Administrator",
	"components.structure.6s7iy8": "Are you sure to delete this member? It cannot be recovered after deletion.",
	"components.structure.7014jr": "Please select members to delete!",
	"components.structure.j11vpa": "Are you sure to batch delete? It cannot be recovered after deletion.",
	"components.work-platform-dialog.x6sc3u": "Select All",
	"components.work-platform-dialog.s7r6b5": "No staff available",
	"components.work-platform-dialog.hmunnn": "Selected",
	"components.work-platform-dialog.6q24xm": "Clear",
	"components.work-platform-dialog.9f12j5": "Note: The initial password is wlw@123456",
	"components.work-platform-dialog.m324v5": "Add Staff",
	"components.work-platform-dialog.8ai0ei": "Search Department",
	"components.work-platform-dialog.t9ho62": "Please enter keywords to search",
	"components.work-platform-dialog.s4bk51": "Please select staff",
	"external-structure.index.drfp1p": "No external organizations",
	"external-structure.index.78tbs3": "After connecting external organizations, you can achieve online inter-enterprise data reporting, process approval and other collaborations",
	"external-structure.index.17ph48": "Create New Connection",
	"external-structure.index.71b088": "Confirm to disconnect?",
	"external-structure.new-structure.ea1mv8": "Share the link below with partners, who can click to establish a connection relationship.",
	"external-structure.new-structure.wt48d7": "Link Invitation",
	"manage.index.4h2gu3": "System Management",
	"manage.index.5r455g": "Organization Management",
	"manage.index.i3no7f": "Internal Organization",
	"manage.index.k75pu4": "External Organization",
	"manage.index.h774xw": "Application Configuration",
	"manage.index.35ba7b": "Product Management",
	"manage.index.367p5b": "Resource Monitoring",
	"product-manage.index.uw4vxs": "Add Product",
	"product-manage.index.5s7694": "Details",
	"product-manage.index.1s0v45": "Please enter product name",
	"product-manage.index.d2d2go": "Software Product Name",
	"product-manage.index.kiwecx": "Product Code",
	"product-manage.index.o4mc35": "Management Unit",
	"product-manage.index.2g7xpu": "Creation Time",
	"product-manage.index.ebv0c6": "Creator",
	"product-manage.index.50dto8": "Product Description",
	"product-manage.index.8s253c": "Failed to get data",
	"product-manage.productdetail.373uv1": "Product Details",
	"product-manage.productdetail.v5qvv0": "Product Name",
	"product-manage.productdetail.46646r": "Management Department",
	"product-manage.productform.5xi390": "Software product name can only contain Chinese characters, letters, numbers and underscores, and cannot start with numbers, hyphens or underscores",
	"product-manage.productform.2n17j3": "Code cannot be empty",
	"product-manage.productform.luo3w6": "The code can only consist of lowercase letters, numbers, and hyphens, must start with a letter, and end with a letter or number.",
	"product-manage.productform.8k78h4": "Please enter code",
	"product-manage.productform.2h4q55": "Management unit cannot be empty",
	"product-manage.productform.804j65": "Please enter description",
	"product-manage.productform.uvfk5u": "Added successfully",
	"product-manage.productform.3svm4j": "Failed to add",
	"views.login.71to72": "Zhida · Application Building Tool",
	"views.login.2g8tfn": "Production tools for the entire software development process, making software development as simple as building blocks",
	"views.login.hu6fx1": "Zhishu · Data Middle Platform",
	"views.login.gwxd27": "One-stop development and operation platform for the entire data lifecycle, releasing data value and driving business innovation",
	"views.login.tkbs15": "Data Standard Management Platform",
	"views.login.3ojxy2": "Unified standards, precise control - making data governance organized",
	"views.login.39h0w7": "Software Factory · New R&D Model",
	"views.login.s8x41t": "Enterprise digital transformation accelerator, quickly build your exclusive application",
	"views.login.5ul366": "Copyright@2022 Zhongke Meiluo All Rights Reserved",
	"manage.index.1m33r8": "Log Management",
	"manage.index.l1ayi6": "System Log",
	"manage.index.1g13t6": "Application Log",
  "system-log.index.8iz4si": "Search username or ID",
	"system-log.index.61dp1r": "Operation time",
	"system-log.index.tqo7q7": "Operation user",
	"system-log.index.jo781k": "Module name",
	"system-log.index.603pn2": "Behavior",
	"operation-log.index.68j126": "Please select product",
	"operation-log.index.68j127": "Please select application",
	"operation-log.index.68j128": "Please select behavior type",
	"operation-log.index.68j129": "Please select product or application",
	"operation-log.index.1pak36": "To",
	"operation-log.index.hd2sa1": "Start date",
	"operation-log.index.x8k78r": "End date",
	"operation-log.index.cw76nn": "Description",
  "views.login.k42y62": "Copyright © 2025 Meiluo Low-Code Integrated Development Platform",
  "views.login.46q6n6": "Simplified Chinese",
	"system-log.index.6501y8": "Export",
	"system-log.index.keuv7w": "No data available for export",
	"system-log.index.d0g716": "Export successful"
}